import React, { FC } from 'react';
import { BEMHelper } from '@utils/customBEMHelper';

import Tinkoff from './Tinkoff';
import Gazprom from './Gazprom';
import Crypto from './Crypto';
import Stripe from './Stripe';
import Dolyame from './Dolyame';

import { IPaymentOptions } from './interfaces';

import './styles.scss';

const classes = new BEMHelper({
  name: 'payment-options',
});

const PaymentOptions: FC<IPaymentOptions> = ({
  showStripe,
  showDolyame,
  showGazprom = false,
  showCrypto = false,
  ...props
}) => (
  <div className={classes()}>
    {!showStripe && (
      <div className={classes('option')}>
        {showGazprom ? <Gazprom {...props} /> : <Tinkoff {...props} />}
      </div>
    )}

    {showStripe && (
      <div className={classes('option')}>
        <Stripe {...props} />
      </div>
    )}

    {showDolyame && (
      <div className={classes('option')}>
        <Dolyame {...props} />
      </div>
    )}

    {showCrypto && (
      <div className={classes('option')}>
        <Crypto {...props} />
      </div>
    )}
  </div>
);

export default PaymentOptions;
